import Stack from 'components/elements/Stack'
import { ComponentContainer } from 'components/layouts/Layouts.css'
import { ParsedLocale } from 'lib/constants/localization'
import { RefObject } from 'react'
import { Headline3 } from 'stories/elements/Typography/Text'
import SubjectsGrid from 'components/modules/LandingPage/SubjectsGrid'
import theme from 'stories/utils/theme'
import _useTranslation from 'lib/hooks/_useTranslation'
import { trackEvent } from 'lib/tracking/analytics-service'
import { Subject } from 'interfaces/Subject'
import { AnalyticsEventKnowSEOSubjectClick } from 'lib/constants/AnalyticsEventType'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import useMedia from 'lib/hooks/useMedia'

interface Props {
    objectRef: RefObject<HTMLDivElement>
    parsedLocale: ParsedLocale
    isDarkTheme?: boolean
}

const SEOKnowunitySubjects = ({ objectRef, parsedLocale, isDarkTheme }: Props) => {
    const { t } = _useTranslation('knows')
    const lg = useMedia(deviceSize.lg)

    const onKnowSeoSubjectClick = (subject: Subject) => {
        trackEvent(AnalyticsEventKnowSEOSubjectClick, { value: subject.name, valueId: subject.id })
    }

    return (
        <ComponentContainer
            color={isDarkTheme ? theme.colors.darkThemePrimary : theme.colors.backgroundBasic}
            ref={objectRef}
            fitContent
        >
            <section>
                <Stack gutter={40}>
                    <Headline3
                        fontSize={lg ? 24 : 20}
                        fontFamily="var(--font-inter)"
                        fontWeight={600}
                        color={isDarkTheme ? theme.colors.white : theme.colors.subtitleBlack}
                        textAlign="center"
                    >
                        {t('knows/subjectsSectionTitle')}
                    </Headline3>

                    <SubjectsGrid
                        onSubjectClick={onKnowSeoSubjectClick}
                        country={parsedLocale.countryCode}
                        showTitleAsSubHeadline
                        isDarkTheme={isDarkTheme}
                    />
                </Stack>
            </section>
        </ComponentContainer>
    )
}

export default SEOKnowunitySubjects
